/**
 * Маленький тост знизу екрана (юзер 2026-06-25: при копіюванні реф-посилання
 * замість повноекранного попапа — невеликий toast без кнопки, що сам зникає
 * через ~3с). Імперативний стор, як appAlert: showToast(...) з будь-якого
 * місця, <AppToast/> у корені рендерить.
 */
export type ToastState = {
  id: number;
  message: string;
  emoji?: string;
};

let current: ToastState | null = null;
const listeners = new Set<() => void>();
let seq = 0;

function emit() {
  for (const l of listeners) l();
}

export function showToast(message: string, opts?: { emoji?: string }): void {
  seq += 1;
  current = { id: seq, message, emoji: opts?.emoji };
  emit();
}

export function clearToast(): void {
  current = null;
  emit();
}

export function getToast(): ToastState | null {
  return current;
}

export function subscribeToast(listener: () => void): () => void {
  listeners.add(listener);
  return () => {
    listeners.delete(listener);
  };
}
